import { accessRoute } from '../../routes/Dashboard';
import i18next from 'i18next';
export const bulkUploadBreadcrumb = () => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: '#',
      name: i18next.t('text.quote.uploadBtn'),
    },
  ];
};
